import { render, staticRenderFns } from "./order-stats.vue?vue&type=template&id=bbd243b6&scoped=true&"
import script from "./order-stats.vue?vue&type=script&lang=js&"
export * from "./order-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd243b6",
  null
  
)

export default component.exports